<div class="row">
    <div class="col-12">
      <div class="content-header">Attendance  Form</div>
    </div> 
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
            <h4 class="card-title">Basic</h4>
          </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <form [formGroup]="attendanceForm">
                    <fieldset class="form-group mt-3" *ngIf="currentUser.roles =='admin'">
                      <ng-select
                        [items]="usersList"
                        bindLabel="name"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select User"
                        [(ngModel)]="selectedValue"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getUserId($event)"
                      >
                      </ng-select>
                    </fieldset>
                    <fieldset class="form-group">
                      <label for="attendanceDate">Date</label>
                      <input
                      type="date"
                      formControlName="attendanceDate"
                      class="form-control"
                      id="attendanceDate"
                      placeholder="Enter attendanceDate"
                      [ngClass]="{
                        'is-invalid':
                        attendanceFormSubmitted && rf.attendanceDate.invalid,
                        'is-valid':
                        attendanceFormSubmitted && !rf.attendanceDate.invalid
                      }"
                      required
                    />  
                    <div
                      *ngIf="rf.attendanceDate.touched && rf.attendanceDate.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Attendance Date is
                      required
                    </div>
                  </fieldset>

                  <div class="row">
                    <div class="col-6 col-md-6">
                    <fieldset class="form-group">
                        <label for="startTime">start  Time</label>
                        <ngb-timepicker formControlName="startTime" ></ngb-timepicker>
                        <!-- <button class="btn btn-outline-{{meridian ? 'success' : 'danger'}} mb-3 mt-3">
                          Meridian - {{meridian ? "ON" : "OFF"}}
                      </button> -->
                          <!-- <ngb-timepicker [(ngModel)]="time" [ngModelOptions]="{standalone: true}"></ngb-timepicker> -->
                          <!-- <button class="btn mb-3 mt-3" style="opacity: 0;">&nbsp;</button> -->
                          
                          <!-- <p>Selected time: {{time | json}}</p> -->
                        
                        <!-- <input
                          type="time"
                          formControlName="startTime"
                          class="form-control"
                          id="startTime"
                          placeholder="Enter startTime"
                          [ngClass]="{
                            'is-invalid':
                            attendanceFormSubmitted && rf.startTime.invalid,
                            'is-valid':
                            attendanceFormSubmitted && !rf.startTime.invalid
                          }"
                          required
                          #startTime
                        /> -->
                        <div
                        *ngIf="rf.startTime.touched && rf.startTime.errors?.required"
                        class="help-block mt-1 text-danger"
                      >
                          <i class="ft-alert-circle align-middle"></i> StartTime is
                          required
                        </div>
                      </fieldset>
                    </div> 
                    <div class="col-6 col-md-6">
                    <fieldset class="form-group">
                      <label for="endTime">end Time</label>
                      <ngb-timepicker formControlName="endTime"  ></ngb-timepicker>
                      <!-- <input
                        type="time"
                        formControlName="endTime"
                        class="form-control"
                        id="endTime"
                        placeholder="Enter endTime"
                        [ngClass]="{
                          'is-invalid':
                          attendanceFormSubmitted && rf.endTime.invalid,
                          'is-valid':
                          attendanceFormSubmitted && !rf.endTime.invalid
                        }"
                        required
                        #endTime
                      /> -->
                      <div
                        *ngIf="rf.endTime.touched && rf.endTime.errors?.required"
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> EndTime is
                        required
                      </div>
                    </fieldset>
                    </div>
                  </div>
    
                  </form>
                </div>
                <div class="col-md-6">
                  <form [formGroup]="attendanceForm">
                    
                       <!-- <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" formControlName="attendanceDate" name="dp"   ngbDatepicker
                        [dayTemplate]="customDay" [markDisabled]="isDisabled" #d3="ngbDatepicker">
                        <div class="input-group-append">
                          <div class="input-group-text" (click)="d3.toggle()">
                            <i class="fa fa-calendar" style="cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                      <ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected"
                      let-disabled="disabled">
                      <span class="custom-day" [class.weekend]="isWeekend(date)" [class.bg-primary]="selected"
                        [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                        {{ date.day }}
                      </span>
                    </ng-template>  -->
                    <!-- <fieldset class="form-group">
                      <label for="attendanceDate">Date</label>
                       <input
                        type="date"
                        formControlName="attendanceDate"
                        class="form-control"
                        id="attendanceDate"
                        placeholder="Enter attendanceDate"
                        [ngClass]="{
                          'is-invalid':
                          attendanceFormSubmitted && rf.attendanceDate.invalid,
                          'is-valid':
                          attendanceFormSubmitted && !rf.attendanceDate.invalid
                        }"
                        required
                      />  
                      <div
                        *ngIf="rf.attendanceDate.touched && rf.attendanceDate.errors?.required"
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Attendance Date is
                        required
                      </div>
                    </fieldset> -->
                    <fieldset class="form-group">
                        <label for="notes">notes</label>
                        <textarea formControlName="notes" id="hidden-label-form-6" rows="5" class="form-control "
                          placeholder="Enter notes" [ngClass]="{ 'is-invalid':
										 attendanceFormSubmitted && rf.notes.invalid, 'is-valid':
										 attendanceFormSubmitted && !rf.notes.invalid }"
										 required #whoShouldJoin></textarea>
                        <!-- <input
                          type="text"
                          formControlName="notes"
                          class="form-control"
                          id="notes"
                          placeholder="Enter notes"
                          [ngClass]="{
                            'is-invalid':
                            attendanceFormSubmitted && rf.notes.invalid,
                            'is-valid':
                            attendanceFormSubmitted && !rf.notes.invalid
                          }"
                          required
                        /> -->
                        <div
                          *ngIf="rf.notes.touched && rf.notes.errors?.required"
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> Notes is
                          required
                        </div>
                      </fieldset>

                      <fieldset class="form-group">
                        <label for="task">task</label>
                        <input
                          type="text"
                          formControlName="task"
                          class="form-control"
                          id="task"
                          placeholder="Enter task"
                          [ngClass]="{
                            'is-invalid':
                            attendanceFormSubmitted && rf.task.invalid,
                            'is-valid':
                            attendanceFormSubmitted && !rf.task.invalid
                          }"
                          required
                        />
                        <div
                          *ngIf="rf.task.touched && rf.task.errors?.required"
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> Task is
                          required
                        </div>
                      </fieldset>
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                       
                        (click)="submitForm()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                        (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
